import React, { useState, useEffect } from 'react';
import NewFiltersItemList from './NewFiltersItemList';

function NewFiltersItem({ filters,
    selectedFilters,
    ...others }) {
    const [currentFilters, setCurrentFilters] = useState(filters),
        [currentSelectedFilters, setCurrentSelectedFilters] = useState(selectedFilters);
    useEffect(() => {
        setCurrentFilters(filters);
        setCurrentSelectedFilters(selectedFilters);
    }, [filters, selectedFilters]);
    const listItems = currentFilters.map((filter, filterIndex) => {
        return <NewFiltersItemList key={`current-filters-${filterIndex}`} filter={filter}
            selectedFilters={currentSelectedFilters}
            {...others} />
    })
    return listItems;
};

export default NewFiltersItem;